import { FETCH_ACTIVITY_TYPES_SUCCEEDED } from './activityType.action';
import { pathOr } from 'ramda';

export const activityTypeReducer = (state = [], action) => {
	switch (action.type) {
		case FETCH_ACTIVITY_TYPES_SUCCEEDED: {
			return pathOr([], ['payload', 'data'], action);
		}

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/redux/activityTypes/activityType.reducer.js